import { AlarmFeedKey, AlarmItem } from '@/types';
import { apiClient } from '../client';

export async function listAlarms(): Promise<AlarmItem[]> {
  const { data } = await apiClient.get<AlarmItem[]>('/alarms');
  return data;
}

export async function getAlarmFeed(key: AlarmFeedKey): Promise<AlarmItem[]> {
  const { data } = await apiClient.get<AlarmItem[]>(`/alarms/feed/${key}`);
  return data;
}

export async function acknowledgeAlarm(id: string, acknowledged: boolean): Promise<AlarmItem> {
  const { data } = await apiClient.patch<AlarmItem>(`/alarms/${id}/ack`, { acknowledged });
  return data;
}

export async function acknowledgeAllAlarms(): Promise<AlarmItem[]> {
  const { data } = await apiClient.post<AlarmItem[]>('/alarms/ack-all');
  return data;
}
